/**
 * Reglas del snapshot personal de una ruta de autoaprendizaje.
 * snapshot = null  -> la persona no tiene snapshot: se usa el temario vivo.
 * Recurso en la ruta pero no en el snapshot (agregado después) -> no cuenta / opcional.
 * Recurso quitado de la ruta -> deja de existir en el temario vivo y no se exige.
 */
export type SelfPacedSnapshot = Map<string, boolean> | null;

export function resolveSnapshotLink(
  snapshot: SelfPacedSnapshot,
  contentId: string,
  liveMandatory: boolean,
): { counts: boolean; mandatory: boolean } {
  if (!snapshot) return { counts: true, mandatory: !!liveMandatory };
  if (!snapshot.has(contentId)) return { counts: false, mandatory: false };
  return { counts: true, mandatory: snapshot.get(contentId) === true };
}

/** Un recurso suma al % de la ruta solo si cuenta para la persona y es obligatorio. */
export function countsTowardProgress(
  snapshot: SelfPacedSnapshot,
  contentId: string,
  liveMandatory: boolean,
): boolean {
  const r = resolveSnapshotLink(snapshot, contentId, liveMandatory);
  return r.counts && r.mandatory;
}

/** Recurso agregado a la ruta después de que la persona se inscribió. */
export function isAddedAfterEnrollment(snapshot: SelfPacedSnapshot, contentId: string): boolean {
  return !!snapshot && !snapshot.has(contentId);
}
